import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'; // import cx from 'classnames'

import i18n from 'i18next';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { TablePagination } from '@material-ui/core';
import DateRange from '../ui/react-ui/date-range';
import DataTable from '../ui/table';
import SearchBar from '../ui/searchBar';
import AuditLogDetail from './auditLog-detail'; // api

import { getAuditLogList } from '../../api/settingAPI.js';
var t = i18n.getFixedT(null, 'audit-log');
var gt = i18n.getFixedT(null, 'app');

var AuditLog = function AuditLog(props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot;

  var dispatch = useDispatch();
  var id = props.id;
  var initDateTime = {
    from: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm'),
    to: moment().format('YYYY-MM-DD HH:mm')
  };

  var _useState = useState(initDateTime),
      _useState2 = _slicedToArray(_useState, 2),
      dateTime = _useState2[0],
      setDateTime = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      auditLogData = _useState4[0],
      setAuditLogData = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      currentPage = _useState6[0],
      setCurrentPage = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      totalCount = _useState8[0],
      setTotalCount = _useState8[1];

  var _useState9 = useState(10),
      _useState10 = _slicedToArray(_useState9, 2),
      rowsPerPage = _useState10[0],
      setRowsPerPage = _useState10[1];

  var _useState11 = useState({
    field: 'dateTime',
    desc: true
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      tableSort = _useState12[0],
      setTableSort = _useState12[1];

  var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      keyword = _useState14[0],
      setKeyword = _useState14[1];

  var _useState15 = useState(),
      _useState16 = _slicedToArray(_useState15, 2),
      dialogData = _useState16[0],
      setDialogData = _useState16[1];

  var isMounted = useRef(false);

  var handleChangeDateTime = function handleChangeDateTime(dateTime) {
    setDateTime(dateTime);
  };

  var handleChangePage = function handleChangePage(e, newPage) {
    setCurrentPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleSort = function handleSort(sort) {
    setTableSort(sort);
  };

  var fetchData = function fetchData() {
    var isInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var _currentPage, _rowsPerPage, _keyword, _dateTime;

    _currentPage = isInit ? 0 : currentPage;
    _rowsPerPage = isInit ? 10 : rowsPerPage;
    _keyword = isInit ? '' : keyword;
    _dateTime = isInit ? initDateTime : dateTime;

    var offset = (Number(_currentPage + 1) - 1) * _rowsPerPage;

    getAuditLogList(contextRoot, false, _keyword, _dateTime, tableSort, offset, _rowsPerPage).then(function (result) {
      var newData = _.map(result.content, function (el, index) {
        return _objectSpread(_objectSpread({}, el), {}, {
          sequence: offset + index + 1
        });
      });

      setAuditLogData(newData);
      setTotalCount(result.totalElements);
    });
  };

  useEffect(function () {
    if (!isMounted.current) return;
    fetchData();
  }, [keyword, JSON.stringify(tableSort), currentPage, rowsPerPage]);
  useEffect(function () {
    if (!isMounted.current) {
      fetchData(true);
      isMounted.current = true;
    }

    return function () {};
  }, []);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'moduleName', {
    label: t('lbl-module-name'),
    sortable: true
  });

  _.set(fields, 'actionName', {
    label: t('lbl-action-name'),
    sortable: true
  });

  _.set(fields, 'target', {
    label: t('lbl-target'),
    sortable: true
  });

  _.set(fields, 'userName', {
    label: t('lbl-username'),
    sortable: true
  });

  _.set(fields, 'displayName', {
    label: t('lbl-display-name'),
    sortable: true
  });

  _.set(fields, 'ip', {
    label: t('lbl-ip'),
    sortable: true
  });

  _.set(fields, 'dateTime', {
    label: t('lbl-date-time'),
    sortable: true
  });

  _.set(fields, 'actionResult', {
    label: t('lbl-action-result'),
    sortable: true,
    formatter: function formatter(value) {
      if (value === 0) return /*#__PURE__*/React.createElement("div", null, t('lbl-action-result-success'));
      if (value === 1) return /*#__PURE__*/React.createElement("div", null, t('lbl-action-result-failed'));
      return '';
    }
  });

  _.set(fields, 'severity', {
    label: t('lbl-severity'),
    sortable: true,
    formatter: function formatter(value) {
      if (value === 1) return /*#__PURE__*/React.createElement("div", null, t('lbl-severity-low'));
      if (value === 2) return /*#__PURE__*/React.createElement("div", null, t('lbl-severity-medium'));
      if (value === 3) return /*#__PURE__*/React.createElement("div", null, t('lbl-severity-high'));
      return '';
    }
  });

  _.set(fields, 'more', {
    label: t('lbl-detail'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "icon-block"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return setDialogData(row);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-list-alt"
      })));
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "auditLog-headBar"
  }, /*#__PURE__*/React.createElement(DateRange, {
    id: "auditLog-datetime",
    enableTime: true,
    enableStartEndLabel: true,
    startLabel: t('lbl-start-time'),
    endLabel: t('lbl-end-time'),
    onChange: handleChangeDateTime,
    value: dateTime,
    limitRange: '30d'
  }), /*#__PURE__*/React.createElement("button", {
    className: "button",
    onClick: function onClick() {
      return fetchData();
    }
  }, gt('global.lbl-search'))), /*#__PURE__*/React.createElement("div", {
    className: "auditLog-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-audit-log'))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: auditLogData ? auditLogData : [],
    sort: tableSort,
    onSort: handleSort
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: t('lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: handleChangePage,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  })), !_.isEmpty(dialogData) && /*#__PURE__*/React.createElement(AuditLogDetail, {
    data: dialogData,
    onClose: function onClose() {
      return setDialogData(null);
    }
  }));
};

AuditLog.defaultProps = {
  id: 'g-audit-log'
};
AuditLog.PropTypes = {
  id: PropTypes.string
};
export default AuditLog;